var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7182 4.61031L7.89769 0.789812C7.79222 0.684344 7.64912 0.625 7.5 0.625H1.875C1.25619 0.625 0.75 1.13119 0.75 1.75V15.25C0.75 15.8688 1.25619 16.375 1.875 16.375H6.375V15.25H1.875V1.75H6.375V5.125C6.375 5.74516 6.87956 6.25 7.5 6.25H11.0392C11.429 6.25 11.7773 6.01735 11.9264 5.65729C12.0758 5.29696 11.9939 4.88605 11.7182 4.61031ZM7.5 5.125V1.98293L10.6418 5.125H7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 10.75V9.625H12V8.5H10.875V9.625H10.3125C9.69217 9.625 9.1875 10.1298 9.1875 10.75V11.875C9.1875 12.4952 9.69217 13 10.3125 13H12.5625V14.125H9.1875V15.25H10.875V16.375H12V15.25H12.5625C13.1828 15.25 13.6875 14.7452 13.6875 14.125V13C13.6875 12.3798 13.1828 11.875 12.5625 11.875H10.3125V10.75H13.6875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.b9945405dbde78ecbf1d8ede8e26cfa7.svg";
export { ForwardRef as ReactComponent };